import { lang } from '@umu/ukit-lang';
import React, { useCallback, useMemo, useState } from 'react';

import { isUMUWebview } from '@umu/umu-ua';
import UmuWebview from '@umu/umu-webview';
import { components, services } from 'common';
const { If } = components;
const { Toast } = services;
import { EMediaType } from '@umu/umu-types';
import { ImgCropPortal } from '../@imgCropPortal/imgCropPortal';
import { FileSelect } from '../fileSelect/fileSelect';

interface IProps {
    teacherId: string;
    children: JSX.Element;
    aspect: string; // 宽高比 '3/4'
    isPCCrop?: boolean;
    type?: Array<'camera' | 'album'>;
    onChoosed(url: string): void;
}

import './chooseCropPhoto.scss';
/**
 * @desc 获取裁切图片 web、native
 * @author Kody
 */
export const ChooseCropPhoto = (props: IProps) => {
    const { aspect, teacherId, type = ['camera', 'album'], children, onChoosed } = props;
    const [semiUrl, setSemiUrl] = useState(''); // 原始图片
    const aspectFloat = useMemo(() => {
        const aspectArr = aspect.split('/');
        return Number(aspectArr[0]) / Number(aspectArr[1]);
    }, [aspect]);

    const getPictureFromNative = useCallback(() => {
        UmuWebview.registerHandler('receivePhoto', (data) => {
            if (!data.success) {
                return;
            }

            if (data.imgUrl) {
                onChoosed(data.imgUrl);
            } else if (data.imgArr && data.imgArr.length > 0) {
                onChoosed(data.imgArr[0]);
            }
        });

        UmuWebview.callHandler('getPhoto', {
            type,
            aspect,
            count: 1,
            isCrop: 1,
        });
    }, []);

    const onPreview = (previewUrl: string) => {
        setSemiUrl(previewUrl);
    };

    const onCropCancel = () => {
        setSemiUrl('');
    };

    const onCropConfirm = (url: string) => {
        setSemiUrl('');
        onChoosed(url);
    };

    const onUploadError = () => {
        setSemiUrl('');
        Toast.show({ message: lang('上传失败') });
    };

    const renderBtn = () => {
        const isNative = isUMUWebview;
        return (
            <>
                <If condition={isNative}>
                    <div className="file-select-content-wrap">
                        <button className="choose-crop-phone-btn" onClick={getPictureFromNative}>
                            {children}
                        </button>
                    </div>
                </If>
                <If condition={!isNative}>
                    <FileSelect onPreview={onPreview} mediaType={EMediaType.IMAGE} teacherId={teacherId}>
                        {children}
                    </FileSelect>
                </If>
            </>
        );
    };

    const render = () => {
        return (
            <>
                {renderBtn()}
                <If condition={!!semiUrl}>
                    <ImgCropPortal
                        src={semiUrl}
                        isPCCrop={props.isPCCrop}
                        aspect={aspectFloat}
                        teacherId={teacherId}
                        onErr={onUploadError}
                        onCancel={onCropCancel}
                        onConfirm={onCropConfirm}
                    />
                </If>
            </>
        );
    };

    return render();
};
